import { IconButton, Stack, TooltipHost } from "@fluentui/react";
import { secondsToMilliseconds } from "date-fns";
import { useState, ReactNode } from "react";

interface CopyPasteProps {
  valueToCopy: string;
  tooltipText?: string;
  iconSize?: number;
  iconColor?: string;
  iconPosition?: "before" | "after";
  children: ReactNode;
}

export function CopyPaste({
  valueToCopy,
  tooltipText = "Copiar",
  iconSize = 16,
  iconColor,
  iconPosition = "after",
  children
}: CopyPasteProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard.writeText(valueToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), secondsToMilliseconds(2));
  };

  const copyIcon = (
    <TooltipHost content={tooltipText}>
      <IconButton
        iconProps={{
          iconName: copied ? "CheckMark" : "Copy",
          styles: { root: { fontSize: iconSize, color: iconColor } }
        }}
        onClick={handleCopy}
        ariaLabel={tooltipText}
      />
    </TooltipHost>
  );

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 6 }}>
      {iconPosition === "before" && copyIcon}
      <button
        onClick={handleCopy}
        style={{
          all: "unset",
          fontWeight: "bold",
          cursor: "pointer",
          color: "inherit"
        }}
      >
        {children}
      </button>

      {iconPosition === "after" && copyIcon}
    </Stack>
  );
}
